import roofImageSlice from "./roof-image.slice";

export * from "./roof-image.saga";
export * from "./roof-image.slice";

export default roofImageSlice.reducer;
